module.exports = __webpack_public_path__ + "static/img/paper_texture.6f08e5e3.jpg";